import { render } from "./tabCategorias.vue?vue&type=template&id=45531944&scoped=true"
import script from "./tabCategorias.vue?vue&type=script&lang=js"
export * from "./tabCategorias.vue?vue&type=script&lang=js"

import "./tabCategorias.vue?vue&type=style&index=0&id=45531944&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45531944"]])

export default __exports__